module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_1.89a11b7c.png";